import { getStartDate } from '@akin-home/calendar';
import { useListCalendarItems } from '@akin-home/calendar/combined';
import { useHabitatID } from '@akin-home/habitats/react';
import { endOfDay, isSameDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';

export const useGetCalendarItemsForDay = (active_date_string: string) => {
  const habitatID = useHabitatID();

  const { items, isLoading } = useListCalendarItems({
    params: {
      habitatID,
      filter: {
        from: startOfDay(new Date(active_date_string)).toISOString(),
        to: endOfDay(new Date(active_date_string)).toISOString(),
      },
    },
  });

  const itemsForDay = useMemo(
    () =>
      items?.filter((i) =>
        isSameDay(getStartDate(i), new Date(active_date_string))
      ),
    [items, active_date_string]
  );

  return {
    itemsForDay,
    isLoading,
  };
};
